import Auth_API from "./apiConfig";

export const postApi = {
  getAllPosts: async (
    page = 1,
    limit = 30,
    query = "",
    mySavedPosts = false,
    noRestrict = false
  ) => {
    try {
      const params = {
        page: page,
        limit: limit
      };

      if (query) params.q = query;
      if (mySavedPosts === true) params.my_saved_posts = mySavedPosts;
      if (noRestrict) params.no_restrict = noRestrict;



      const response = await Auth_API.get(`/post/all`, { params });
      // console.log(response.data, 'RESP DATA _ API')
      return response.data;
    } catch (error) {
      console.error(
        "Get all posts failed",
        error?.response?.data || error.message
      );
      throw error;
    }
  },

  togglelikePost: async (pid, status, params) => {
    try {
      const endpoint = status ? `/post/unlike/${pid}` : `/post/like/${pid}`;
      const response = await Auth_API.post(endpoint, params);
      return response.data;
    } catch (error) {
      console.error(
        "Like/Unlike post failed",
        error?.response?.data || error.message
      );
      throw error;
    }
  },

  callVoteAPollOption: async (optionId) => {
    try {
      const response = await Auth_API.post(`/post/poll/vote/${optionId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Vote poll failed",
        error?.response?.data || error.message
      );
      throw error;
    }
  },


  // create by chakri
  createComment: async (pid, comment, community_user = "") => {
    try {
      const response = await Auth_API.post(`/post/comment/${pid}`, { text: comment, community_user });
      return response.data;
    } catch (error) {
      console.error(
        "Create comment failed",
        error?.response?.data || error.message
      );
      throw error;
    }
  },

  // getCommentOfPost: async (pid) => { 
  //   try {
  //     const response = await Auth_API.get(`/post/comment/${pid}`);
  //     console.log("response", response)
  //     return response.data;
  //   } catch (error) {
  //     console.error(
  //       "Get comment failed",
  //       error?.response?.data || error.message
  //     );
  //     throw error;
  //   }
  // }


   createPostApi :async (data) => {
    try {
      const response = await Auth_API.post(`/post/create`, data);
      return response.data;
    } catch (error) {
      console.error(
        "Create post failed:",
        error?.response?.data || error.message
      );
      throw error;
    }
  },
 deletePost : async (pid) => {
    try {
      
      const response = await Auth_API.post(`/post/delete/${pid}`);
      return response.data;
    } catch (error) {
      console.error(
        "Delete post failed:",
        error?.response?.data || error.message
      );
      throw error;
    }
  },
  getPostById: async (postId) => {
    try {
      const response = await Auth_API.get(`/post/get/${postId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Get post by ID failed",
        error?.response?.data || error.message
      );
      throw error;
    }
  },
  updatePostApi :async ( id,data) => {
    try {
      const response = await Auth_API.post(`/post/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(
        "update post failed:",
        error?.response?.data || error.message
      );
      throw error;
    }
  },

  toggleSavePostApi :async ( id,isSaved) => {
    try {
      const endpoint = isSaved ? `/post/action/unsave/${id}` : `/post/action/save/${id}`;
      const response = await Auth_API.post(endpoint);
      return response.data;
    } catch (error) {
      console.error(
        "Save/Unsave post failed:",
        error?.response?.data || error.message
      );
      throw error;
    }
  },

  reportPost :async (post_id,data) => {
    try {
      const endpoint = `/post/action/report/${post_id}`;
      const response = await Auth_API.post(endpoint,data);
      return response.data;
    } catch (error) {
      console.error(
        "Save/Unsave post failed:",
        error?.response?.data || error.message
      );
      throw error;
    }
  },
};
